import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar";
import ProductHeader from "../../component/ProductHeader";
import Footer from "../../component/Footer";
import Images from "../../assets/Image";
import { FaDownload } from "react-icons/fa";
import ContactUsFooter from "../../component/ContactUsFooter";
import MostlyViewed from "../../component/MostlyViewed";
import SpecificationViewed from "../../component/SepcificationViewed";
import FilePdf from "../../broucherPdf/filePdf";
import copilotgemini from "../../assets/copilotgemini.png";

export default function CopilotGemini() {
  const [specificationVisible, setSpecificationVisible] = useState(false);
  const [youtubeVideoVisible, setYoutubeVideoVisible] = useState(false);
  const [printerDetailsVisible, setPrinterDetailsVisible] = useState(false);
  const containerRef = useRef(null);
  const youtubeContainerRef = useRef(null);
  const printerDetailsRef = useRef(null);

  const leftSidePrinterSpecification = [
    {
      title: "Print Technology",
      data: "Piezo impulse printhead technology",
    },
    {
      title: "Print Speed",
      data: "Up to 220 ft/min.",
    },
    {
      title: "Product Sensor",
      data: "External defuse beam photocell standard.",
    },
    {
      title: "Agency Certifications",
      data: "CE",
    },
    {
      title: "Horizontal Print Resolution",
      data: "150 or 300 dpi",
    },
    {
      title: "Low Ink Indicator",
      data: "Status alert on touchscreen, LED light beacon optional",
    },
  ];
  const rightSidePrinterSpecification = [
    {
      title: "Touch Screen/Display",
      data: "4.3” (10.9 cm) full color touchscreen display",
    },
    {
      title: "Vertical Print Resolution",
      data: "360 dpi capable of printing razor-sharp graphics, small character text and scannable bar codes",
    },
    {
      title: "Max Print Lines",
      data: "5.6” (14.2 cm) total",
    },
    {
      title: "Electrical Requirements",
      data: "100 – 240 VAC, 50/60 Hz, 65W max",
    },
    {
      title: "Communication Interface",
      data: "One USB host and one Ethernet input",
    },
    {
      title: "Time & Date",
      data: "Internal real time clock with battery back-up",
    },
  ];
  const foodAndBeverage1 = [
    {
      productImg: Images?.industry5,
      label: "Food & Beverage",
      pageNavigate: "/byindustry/foodandbeverage",
    },
    {
      productImg: Images?.industry1,
      label: "Automobile",
      pageNavigate: "/byindustry/automobile",
    },
    {
      productImg: Images?.industry7,
      label: "Pharma",
      pageNavigate: "/byindustry/pharma",
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSpecificationVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setYoutubeVideoVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (youtubeContainerRef.current) {
      observer.observe(youtubeContainerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setPrinterDetailsVisible(true);
          observer.disconnect(); // Stop observing once visible
        }
      },
      { threshold: 0.3 }
    );

    if (printerDetailsRef.current) {
      observer.observe(printerDetailsRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const downloadLinkRef = useRef(null);

  const handleDivClick = () => {
    if (downloadLinkRef.current) {
      downloadLinkRef.current.click();
    }
  };

  return (
    <div>
      <Navbar />
      <ProductHeader
        headerTxt="COPILOT GEMINI"
        printerImg={Images?.uspstream7}
        pdfFile={FilePdf?.Co_Pilot_Gemini}
      />
      <div className="printerPageContainer">
        <div className="printerDetailsContainer">
          <header
            className={`printerDetailsHeader ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            COPILOT GEMINI
          </header>
          <div
            ref={printerDetailsRef}
            // className="printerDetailsData"
            className={`printerDetailsData ${
              printerDetailsVisible ? "animated" : ""
            }`}
          >
            Squid Ink's CoPilot Gemini™ printing system is designed to print
            superior quality hi-resolution characters on porous or non-porous
            surfaces. For applications that require immediate dry times on non-
            porous surfaces, the CoPilot Gemini also has the capability to run
            UV LED curable inks. With a massive 5.6" of print height and print
            speeds up to 220 ft/ min, the CoPilot Gemini provides a cost
            effective solution for making your mark on a wide variety of
            products and substrates.
          </div>
          <div className="printerDetailsVideo" ref={youtubeContainerRef}>
            {/* <div className="printerYoutubeLink">
              <iframe
                // className={`youtubeVideo `}
                className={`youtubeVideo ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                width="300"
                height="250"
                src="https://www.youtube.com/embed/jMFx1pUakkU?si=oDSbquQyGUGkTZEt"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                style={{ borderRadius: "6px" }}
              ></iframe>
            </div> */}
            <div>
              <div
                className={`printerBrochure ${
                  youtubeVideoVisible ? "animated" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={handleDivClick}
              >
                <div>
                  <div className="productImageContainer">
                    <img className="w-[100%]" src={copilotgemini} alt="" />
                  </div>
                  {/* Buttons */}
                  <div className="brochureImageButtons">
                    <button className="downloadBrochureBtn">
                      Download Brochure
                    </button>
                  </div>
                  <a
                    href={FilePdf?.Co_Pilot_Gemini}
                    download="CoPilot Gemini.pdf"
                    ref={downloadLinkRef}
                    style={{ display: "none" }}
                  >
                    Download Brochure
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="printerSpecificationContainer">
          <header className="printerDetailsHeader">Specification</header>
          <div
            ref={containerRef}
            className="printerSpecificationDetailsContainer"
          >
            <div className="leftSideSpecificationContainer">
              {leftSidePrinterSpecification.map((item, index) => (
                <div
                  className={`specificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
            <div className="rightSideSpecificationContainer">
              {rightSidePrinterSpecification.map((item, index) => (
                <div
                  className={`rightSpecificationDetails ${
                    specificationVisible ? "animated" : ""
                  }`}
                  key={index}
                  style={{
                    animationDelay: specificationVisible
                      ? `${index * 0.2}s`
                      : "0s",
                  }}
                >
                  <div className="specificationTitle">{item.title}</div>
                  <div className="specificationData">{item.data}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <SpecificationViewed foodAndBeverage1={foodAndBeverage1} />
        <MostlyViewed />
      </div>
      <ContactUsFooter />
      <Footer />
    </div>
  );
}
